import { Area, BOMType, IViolation, TaskListCharacteristic } from 'src/app/models';

export abstract class MultiKVCode510Validation {
  /**
   * Validation MultiKVCode510,
   * A violation is returned if a material of type 'Multi-K' or 'Co-inj.'
   * has master technical specification with visual characteristics
   * missing the required V-code, or using the wrong V-code for the element type.
   *
   * @remarks
   * Regular elements require `V510`; DUPLO elements require `VD510`. Using the code from the
   * opposite family is a violation, and so is missing the required code entirely.
   */
  public static validate(
    characteristics: TaskListCharacteristic[],
    bomType?: BOMType | '',
    isDuplo = false
  ): IViolation[] {
    if (!bomType || ![BOMType.MultiK, BOMType.Coinjection].includes(bomType)) {
      return [];
    }

    // Guard: an empty array means no characteristics to validate or build a path from.
    if (characteristics.length === 0) {
      return [];
    }

    const requiredCode = isDuplo ? 'VD510' : 'V510';
    const forbiddenCode = isDuplo ? 'V510' : 'VD510';

    const hasRequired = characteristics.some(
      ({ mValidationCode }) => mValidationCode === requiredCode
    );

    const wrong = characteristics.find(({ mValidationCode }) => mValidationCode === forbiddenCode);

    const violations: IViolation[] = [];

    if (wrong) {
      violations.push({
        message: `${forbiddenCode} is not allowed on a ${
          isDuplo ? 'DUPLO' : 'regular'
        } multi component element (expected ${requiredCode})`,
        pathToViolation: MultiKVCode510Validation.pathToViolation(wrong),
      });
    }

    if (!hasRequired) {
      violations.push({
        message: `${requiredCode} is missing from the master technical specification for this ${
          isDuplo ? 'DUPLO ' : ''
        }multi component element`,
        pathToViolation: MultiKVCode510Validation.pathToViolation(characteristics[0]),
      });
    }

    return violations;
  }

  private static pathToViolation(characteristic: TaskListCharacteristic) {
    return [
      { area: Area.Specifications },
      {
        area: Area.TechnicalSpecification,
        displayId: `${characteristic.taskListGroup}-${characteristic.groupCounter}`,
        id: `Q-${characteristic.taskListGroup}-${characteristic.groupCounter}`,
      },

      {
        area: Area.TechnicalSpecificationOperation,
        id: characteristic.infoField2,
      },
      {
        area: Area.TechnicalSpecificationCharacteristics,
        displayId: characteristic.characteristic,
        id: characteristic.id,
      },
    ];
  }
}
